export default __webpack_public_path__ + "images/JON.a5cc619.png";